import React from 'react'

const Resume = () => {
    return (
        <a
            href="./assets/Raunak_Kesarwani_Resume.pdf"
            download="Raunak_Kesarwani_Resume.pdf"
            className="resume-btn"
        >
            Download Resume
        </a>
    )
}

export default Resume